/* global $:false */

// Autosized textareas ($text fields, marked with AUTOSIZE_CLASS) are kept as tall as their content.
//
// They need to be (re)measured when they become visible (e.g. when a collapsed block is expanded), because while
// hidden they have no size. All the work is done in batches, reading all the sizes before writing any, so that the
// browser only needs to compute the layout once, even in instances with thousands of fields.
//
// Other components ($markdown editors, $references grids, ...) and customizations redraw themselves on window resize.

const AUTOSIZE_CLASS = 'js-autosize';

const _isRendered = (el) => el.offsetParent !== null;

const _resizeTextareas = function(textareas) {
    textareas.forEach((ta) => { ta.style.height = 'auto'; });
    const heights = textareas.map((ta) => ta.scrollHeight);
    textareas.forEach((ta, i) => { ta.style.height = heights[i] + 'px'; });
};

// Resizes the visible autosized textareas inside `root` (an element, defaults to the whole document).
const resizeAutosizedTextareas = function(root = document) {
    _resizeTextareas(Array.from(root.querySelectorAll('textarea.' + AUTOSIZE_CLASS)).filter(_isRendered));
};

// Resizes one textarea to its content, e.g. as the content changes
const resizeTextarea = function(textarea) {
    _resizeTextareas([textarea]);
};

let _scheduled = false;

// Resizes the visible autosized textareas of the whole document and triggers a window resize, but only once
// before the next paint, no matter how many times it's called until then (e.g. once for all the fields expanded by
// "expand all").
//
// The window resize is what makes the other components and customizations redraw themselves when they become visible.
const scheduleResizeAll = function() {
    if (_scheduled) return;

    _scheduled = true;
    window.requestAnimationFrame(() => {
        _scheduled = false;
        resizeAutosizedTextareas(document);
        $(window).trigger('resize');
    });
};

export { AUTOSIZE_CLASS, resizeAutosizedTextareas, resizeTextarea, scheduleResizeAll };
